module.exports = __webpack_public_path__ + "img/GENERAL-SWIFT-BOOSTER-GREEN-1.62c774fa.jpg";